import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../constants/common'
import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../../Entity'
import { formValidationSchemaNoChanged } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { toUserSelectItem } from '../../../User'

import {
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER,
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS,
  EDIT_MANAGERS_FORM_INITIAL_VALUES,
} from './BuildingGroupsEditManagersActionModal.constants'

export function getInitialValues({ itemAction, users }) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...EDIT_MANAGERS_FORM_INITIAL_VALUES,
    [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER]:
      users?.map(toUserSelectItem) || EMPTY_LIST,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
  }
}

export function getValidationSchema({ initialValues, itemAction }) {
  return Yup.object({
    [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER]: Yup.array().when(
      FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
      {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }
    ),
    [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS]: Yup.boolean(),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: {
            name: BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER,
          },
        })
      ),
  })
}
